import React from "react";
import styles from "../details.module.css";

type HProps = {
  text: string;
}

const Heading: React.FC<HProps> = ({ text }) => <div className={styles.heading}>{text}</div>;

export default Heading;
